import { useState } from "react";
import { faqItems } from "@/mocks/home";
import SectionHeading from "@/pages/home/components/SectionHeading";

export default function FaqSection() {
  const [active, setActive] = useState<number | null>(0);

  return (
    <section id="faq" className="border-t border-background-200 bg-background-100">
      <div className="px-4 py-12 md:px-6 md:py-16">
        <div className="mx-auto grid max-w-page grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-12">
          <div className="lg:col-span-4">
            <SectionHeading
              index="06 / 常见问题"
              title="找不到入口时，先看这几条"
              desc="关于最新地址、App 下载与线路选择的常见疑问，都在这里给出直接答案。"
            />
            <div className="mt-6 rounded-lg border border-background-200 bg-background-50 px-5 py-4">
              <p className="text-sm leading-relaxed text-foreground-600">
                还有别的情况？先把更新条与线路状态各看一遍，多数「打不开」都能在那两处找到原因。
              </p>
            </div>
          </div>

          <div className="lg:col-span-8">
            <div className="overflow-hidden rounded-xl border border-background-200 bg-background-50">
              {faqItems.map((item, index) => {
                const isOpen = active === index;
                return (
                  <div key={item.q} className="border-b border-background-200 last:border-0">
                    <button
                      type="button"
                      onClick={() => setActive(isOpen ? null : index)}
                      className="flex w-full cursor-pointer items-center justify-between gap-4 px-5 py-4 text-left"
                    >
                      <span className="flex items-center gap-3">
                        <span className="font-mono text-xs text-primary-600">
                          {String(index + 1).padStart(2, "0")}
                        </span>
                        <span className="font-heading text-sm font-bold text-foreground-950 md:text-base">
                          {item.q}
                        </span>
                      </span>
                      <i
                        className={`shrink-0 text-xl text-foreground-500 transition-transform ${isOpen ? "ri-subtract-line" : "ri-add-line"}`}
                      />
                    </button>
                    {isOpen && (
                      <div className="px-5 pb-5 pl-12">
                        <p className="text-sm leading-relaxed text-foreground-600">{item.a}</p>
                      </div>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}